import Crud from '@/views/Company/Crud'
import Add from '@/views/Company/Add'

const routes = {
  path: '/companies',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/companies',
      name: 'list-companies',
      component: Crud,
    },
    {
      path: '/companies/add',
      name: 'Empresa',
      component: Add,
    },
    {
      path: '/companies/edit/:id?',
      name: 'Empresa',
      component: Add,
    },
  ],
}

export default routes
